import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/it';

const MOMENT_LOCALE_BY_I18N: Record<string, string> = {
  en: 'en',
  fr: 'fr',
  es: 'es',
  de: 'de',
  it: 'it',
};

/** Code locale Moment (sans effet de bord) à partir de la langue i18n. */
export function getMomentLocaleFromI18nLanguage(i18nLanguage: string | undefined): string {
  const short = (i18nLanguage || 'fr').split('-')[0]?.toLowerCase() || 'fr';
  return MOMENT_LOCALE_BY_I18N[short] || 'fr';
}

/**
 * Aligne la locale globale Moment sur la langue i18n (codes courts, ex. fr-FR → fr).
 * À appeler depuis useLayoutEffect sur les écrans qui formatent des dates avec Moment,
 * pour éviter un premier paint avec une locale résiduelle incorrecte.
 */
export function applyMomentLocaleFromI18nLanguage(i18nLanguage: string | undefined): string {
  const momentLocale = getMomentLocaleFromI18nLanguage(i18nLanguage);
  moment.locale(momentLocale);
  moment.updateLocale(momentLocale, { week: { dow: 1 } });
  return momentLocale;
}
